/**
 * @generated SignedSource<<96456ce4b4415065caea1e5e5b27bae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreQuoteTitle_shipmentQuote$data = {
  readonly buyerServiceMethodDisplay: string | null;
  readonly buyerTotalAmount: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedFormatAmount_financialAmount">;
  } | null;
  readonly handlingTimeDisplay: string | null;
  readonly isFreeToBuyer: boolean | null;
  readonly " $fragmentType": "PreQuoteTitle_shipmentQuote";
};
export type PreQuoteTitle_shipmentQuote$key = {
  readonly " $data"?: PreQuoteTitle_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreQuoteTitle_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFreeToBuyer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerServiceMethodDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handlingTimeDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "buyerTotalAmount",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFormatAmount_financialAmount"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "0b6feead3f310a4a6a09210f35ab583e";

export default node;
